export default {
  vmPrices: [],
  vmPrice: {}
}